module.exports = __webpack_public_path__ + "src/assets/img/trank_open.1b46e56c.svg";